export const LOGIN = "/authentication/login";
export const LOGOUT = "/authentication/logout";
export const USER = "/authentication/user";
export const SHIPPING = "/finance/shippingComps";
export const DELETE_SHIPPING = (id: string) => `/finance/shippingComps/${id}`;
export const UPDATE_SHIPPING = (id: string) => `/finance/shippingComps/${id}`;
